import type { HeaderContext } from '@tanstack/react-table';
import type { DataTableColumnHeaderMeta } from 'src/registry/components/table/types';

interface DataTableColumnGenericHeaderDefinitionProps<TData, TValue> extends HeaderContext<TData, TValue> {}

export function DataTableColumnGenericHeaderDefinition<TData, TValue>({
    column,
}: DataTableColumnGenericHeaderDefinitionProps<TData, TValue>) {
    const title = (column.columnDef.meta as DataTableColumnHeaderMeta<TData, TValue>)?.title;

    return <span className="min-w-[1ch] font-mono">{title}</span>;
}

export default DataTableColumnGenericHeaderDefinition;
